<section class="hero-section">

  <!-- 🌄 BACKGROUND MOLINO -->
  <div class="hero-bg-image" aria-hidden="true"></div>

  <!-- 🌊 GRID SUAVE -->
  <div class="hero-grid" aria-hidden="true"></div>

  <div class="hero-layout-container">

    <div class="hero-content">

      <h1>
        Diseño web profesional y
        <span class="text-gradient">automatizaciones a medida</span>
      </h1>

      <p>
        Ayudamos a pequeños negocios y empresas locales a destacar en Google, optimizar su día a día y eliminar el
        trabajo manual con sistemas muy fáciles de usar.
      </p>

      <div class="hero-actions">
        <app-cta-button #ctaBtn variant="primary">
          Solicitar Diagnóstico Gratuito
        </app-cta-button>

        <span class="action-note">
          Es 100% gratuito y sin compromiso
        </span>
      </div>

    </div>

    <app-hero-dashboard></app-hero-dashboard>

  </div>
</section>